import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { EnvironmentProviders, ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { AsyncJobsService } from './async-jobs.service';

@NgModule({ imports: [], providers: [AsyncJobsService, provideHttpClient(withInterceptorsFromDi())] })
export class AsyncJobsModule {
    public static forRoot(cfg: { providers: (Provider | EnvironmentProviders)[]; }): ModuleWithProviders<AsyncJobsModule> {
        return {
            ngModule: AsyncJobsModule,
            providers: cfg.providers
        };
    }
}
